import { TooltipInfo } from "./LineChart"
import { TooltipContentLayout } from "../Tooltip/TooltipContentLayout"
import { Title } from "../Tooltip/Title"
import { Box, Typography } from "@material-ui/core"
import { percentanceFormat } from "../../../helpers/formatters"
import { css } from "@emotion/css"

export const styles = {
  text: ({ color, opacity }: { color: string; opacity?: number }) => css`
    font-size: 12px;
    margin-left: 4px;
    color: ${color};
    opacity: ${opacity || 1};
    line-height: 1.2;
  `,
}

export type TooltipContentProps = {
  data: TooltipInfo
}

export default function TooltipContent({ data }: TooltipContentProps) {
  return (
    <TooltipContentLayout>
      <Title title={data.entity} />
      <Box display="flex" marginBottom="4px" style={{ gap: 4 }}>
        <Typography
          className={styles.text({
            color: "var(--primary-main-light-green)",
          })}
        >
          {data.title}:
        </Typography>
        <Typography
          color="primary"
          className={
            percentanceFormat(data.value) === "N/A" || data.value === 0
              ? styles.text({ color: "var(--white)" })
              : data.value > 0
                ? styles.text({ color: "var(--primary-main-light-green)" })
                : styles.text({ color: "var(--other-red)" })
          }
        >
          <strong>{percentanceFormat(data.value)}</strong>
        </Typography>
      </Box>
    </TooltipContentLayout>
  )
}
